import { useState } from "react";
import { AuthPageLayout } from "./AuthPageLayout";
import { LoadingButton } from "./LoadingButton";
import { PasswordRequirementsHint } from "./PasswordRequirementsHint";
import { PasswordField } from "./PasswordField";

/**
 * 新しいパスワード設定 UI
 */
export const NewPasswordUI: React.FC<{
  loading: boolean;
  error: string | null;
  recoverySuggestion: string | null;
  newPassword: string;
  confirmPassword: string;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({
  loading,
  error,
  recoverySuggestion,
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  onCancel,
}) => {
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <AuthPageLayout>
      {/* タイトル */}
      <h2 className="text-3xl font-bold text-center text-neutral-900 mb-4">
        新しいパスワードの設定
      </h2>
      <p className="text-center text-neutral-600 mb-8">
        初回ログインのため、新しいパスワードを設定してください。
      </p>

      {/* フォーム */}
      <form onSubmit={onSubmit} className="space-y-6">
        <PasswordField
          id="new-password-init"
          name="new-password"
          autoComplete="new-password"
          label="新しいパスワード"
          placeholder="新しいパスワードを入力"
          value={newPassword}
          onChange={onNewPasswordChange}
          show={showNew}
          onToggle={() => setShowNew((v) => !v)}
          disabled={loading}
        />

        <PasswordField
          id="new-password-init-confirm"
          name="confirm-password"
          autoComplete="new-password"
          label="パスワード確認"
          placeholder="もう一度入力してください"
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
          show={showConfirm}
          onToggle={() => setShowConfirm((v) => !v)}
          disabled={loading}
        />

        <PasswordRequirementsHint />

        {/* エラーメッセージ */}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {recoverySuggestion && (
          <div className="text-sm text-neutral-700">{recoverySuggestion}</div>
        )}

        {/* ボタン */}
        <div className="space-y-3">
          <LoadingButton loading={loading} loadingMessage="設定中..." label="設定する" />

          <button
            type="button"
            onClick={onCancel}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white py-4 rounded-2xl text-xl font-bold transition-colors"
            disabled={loading}
          >
            キャンセル
          </button>
        </div>
      </form>
    </AuthPageLayout>
  );
};
